import React from 'react';
import './App.css';
import {Container} from "react-bootstrap";
import Header from './Header';
import Main from "./Main/Main";

function App() {
    return (
        <Container fluid className="p-3">
            <Header/>
            <Main/>
        </Container>

    );
}

export default App;
